import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
// import MenuIcon from '@material-ui/icons/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { Link } from "react-router-dom";
import Button from '@material-ui/core/Button';
import { connect } from "react-redux";
import { compose } from "redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Grid from '@material-ui/core/Grid'
import Modal from '@material-ui/core/Modal';
import ClearIcon from "@material-ui/icons/Clear";
import Phone from "@material-ui/icons/Phone";
import Email from "@material-ui/icons/Email";
import Fab from '@material-ui/core/Fab';
import TextField from '@material-ui/core/TextField';
import { updateUser } from '../actions/UserAction';
// import { fetchUsers } from '../actions/UserAction';
import Card from '@material-ui/core/Card';
// import CardActionArea from '@material-ui/core/CardActionArea';
// import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
// import CardMedia from '@material-ui/core/CardMedia';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Home from "@material-ui/icons/Home";
import Avatar from '@material-ui/core/Avatar';
// import Divider from '@material-ui/core/Divider';
import notfound from '../assets/notfound.png';
import { ATTACHMENT_END_POINT } from "../helpers/constants";
import MenuIcon from '@material-ui/icons/Menu';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Lock from '@material-ui/icons/Lock';
import Person from '@material-ui/icons/Person';
import VpnKey from '@material-ui/icons/VpnKey';
import { changePassword } from '../actions/UserAction';
const { innerWidth } = window;
function getModalStyle() {
	const top = 50;
	const left = 50;

	return {
		top: `${top}%`,
		left: `${left}%`,
		transform: `translate(-${top}%, -${left}%)`,
		// borderBottom: '5px solid black',
	};
}

const styles = theme => ({
	root: {
		flexGrow: 1,
	},
	grow: {
		flexGrow: 1,
	},
	menuButton: {
		marginLeft: -12,
		marginRight: 20,
	},
	gradientBackground: {
		background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
		// background: 'linear-gradient(to right, #2926ac 0%, #0a0a0a 100%)',
		transition: '1200ms',
		zIndex: 3,
		opacity: 0.9
	},

	// paper: {
	// 	position: 'absolute',
	// 	width: theme.spacing.unit * 100,
	// 	backgroundColor: theme.palette.background.paper,
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing.unit * 4,
	// 	outline: 'none',
	// 	//borderRadius: 5
	// 	// borderBottom: '5px solid red'
	// },

	paper: {
		position: 'absolute',
		// width: theme.spacing.unit * 100,
		width: innerWidth >= 480 ? theme.spacing.unit * 100 : (innerWidth - (theme.spacing.unit * 2)),
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
		// padding: '10px 32px 10px 32px',
		outline: 'none',
		borderRadius: 8
	},
	paper1: {
		position: 'absolute',
		// width: theme.spacing.unit * 100,
		width: innerWidth >= 480 ? theme.spacing.unit * 60 : (innerWidth - (theme.spacing.unit * 3)),
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		// padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
		// padding: '10px 32px 10px 32px',
		outline: 'none',
		borderRadius: 8
	},

	margin: {
		margin: theme.spacing.unit,
	},
	closeButtonFab: {
		float: 'right',
		marginRight: '-25px',
		marginTop: '-25px'
	},
	editCloseButtonFab:
	{
		float: 'right',
		marginRight: '-25px',
		marginTop: '-25px'
	},
	editCloseButtonFab2:
	{
		float: 'right',
		marginRight: innerWidth >= 480 ? '-54px' : '-35px',
		marginTop: innerWidth >= 480 ? '-54px' : '-35px'
	},
	editButton: {
		float: 'right',
		marginRight: '-360px',
		marginTop: '20px'
	},
	gradientButton: {
		background: '#2cc676',
		'&:focus': {
			background: '#27ad67'
		},
		'&:hover': {
			background: '#27ad67'
		},
		'&:active': {
			background: '#27ad67'
		}
	},
	backGrd: {
		background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
		height: 20
	},
	cancelbutton: {
		margin: theme.spacing.unit,
	},
	button: {
		background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
		color: 'white'
	},
	textField: {
		// width: 350,
		// marginTop: -8,
		// marginLeft: 8
		margin: 0
	},
	inputStyle: {
		padding: '12px 1px',
		fontSize: 12,
		color: 'rgba(0, 0, 0, 0.87)',
	},
	labelRoot: {
		fontSize: '1.3rem'
	},
	card: {
		maxWidth: theme.spacing.unit * 100,
	
		justifyContent: 'center',
		alignItems: 'center',
		background: 'linear-gradient(to top, #2926ac 0%, #6128be 100%)',
		// background: 'linear-gradient(to right, #2926ac 0%, #0a0a0a 100%)',
		transition: '1200ms',
		zIndex: 3,
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8
		// opacity: 0.7
	},
	card1: {
		maxWidth: theme.spacing.unit * 100,
		marginTop: 10,
		justifyContent: 'center',
		alignItems: 'center',
		//background: 'linear-gradient(to top, #2926ac 0%, #6128be 100%)',
		// background: 'linear-gradient(to right, #2926ac 0%, #0a0a0a 100%)',
		transition: '1200ms',
		zIndex: 3,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8
		// opacity: 0.7
	},
	card2: {
		maxWidth: 400,
		marginTop: 10,
		justifyContent: 'center',
		alignItems: 'center',
		//background: 'linear-gradient(to top, #2926ac 0%, #6128be 100%)',
		// background: 'linear-gradient(to right, #2926ac 0%, #0a0a0a 100%)',
		transition: '1200ms',
		zIndex: 3,

		// opacity: 0.7
	},
	input: {
		display: "none"
	},
	button1: {
		background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
		color: 'white'
	},
	sectionDesktop: {
		display: 'none',
		[theme.breakpoints.up('md')]: {
			display: 'flex',
		},
	},
	sectionMobile: {
		display: 'flex',
		[theme.breakpoints.up('md')]: {
			display: 'none',
		},
	},
	bigAvatar: {
		margin: -50,
		width: 100,
		height: 100,
	  },
	  paperFortimeSlot: {
			position: 'absolute',
			width: innerWidth >= 480 ? theme.spacing.unit * 50 : (innerWidth - (theme.spacing.unit * 2)),
			backgroundColor: theme.palette.background.paper,
			boxShadow: theme.shadows[5],
			padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
			outline: 'none',
			borderRadius: 5
			// borederTop: "5px solid red"
			// borderBottom: '3px solid blue',
			// borderBottom: '5px solid red' 
	},
	closeButtonF: {
			float: 'right',
			marginRight: innerWidth >= 480 ? '-54px' : '-34px',
			marginTop: innerWidth >= 480 ? '-54px' : '-44px'
	},

});

class LaunchHeader extends React.Component {
	state = {
		auth: true,
		anchorEl: null,
		menu: 3,
		open: false,
		userModelOpen: false,
		first_name: "",
		last_name: "",
		email: "",
		phone: "",
		location: "",
		city: "",
		state: "",
		country: "",
		zipcode: "",
		myUser: {},
		user_id: null,
		first_name_error: false,
		last_name_error: false,
		phone_error:false,
		zipcode_error:false,
		user_image: null,
		selected_user_image_name: "",
		mobileMoreAnchorEl: null,
		ChangePasswordModal: false,
		password: "",
		confirm_password: ""
	};

	static getDerivedStateFromProps(props, state) {
		if (state.myUser !== props.user) {
			return {
				myUser: props.user,
			}
		}
		return null;
	}

	handleMenuClose = () => {
		this.setState({ anchorEl: null });
		this.handleMobileMenuClose();
	};

	handleMobileMenuOpen = event => {
		this.setState({ mobileMoreAnchorEl: event.currentTarget });
	};

	handleMobileMenuClose = () => {
		this.setState({ mobileMoreAnchorEl: null });
	};

	handleUserModelOpen = () => {

		this.setState({
			userModelOpen: true,
			open: false,
			first_name: this.props.user.first_name !== "null" ? this.props.user.first_name : "",
			last_name: this.props.user.last_name !== "null" ? this.props.user.last_name : "",
			email: this.props.user.email !== "null" ? this.props.user.email : "",
			phone: this.props.user.phone !== "null" ? this.props.user.phone : "",
			location: this.props.user.location !== "null" ? this.props.user.location : "",
			city: this.props.user.city !== "null" ? this.props.user.city : "",
			state: this.props.user.state !== "null" ? this.props.user.state : "",
			country: this.props.user.country !== "null" ? this.props.user.country : "",
			zipcode: this.props.user.zipcode !== "null" ? this.props.user.zipcode : "",
			selected_user_image_name: Object.keys(this.props.user).length > 0 ? this.props.user.attachments.length > 0 ? this.props.user.attachments[0].file_name : "" : "",

		});

	}

	handleModelOpen = () => {
		this.setState({
			open: true,
			mobileMoreAnchorEl: null
		});
	};
	handleUserModelClose = () => {
		this.setState({
			open: true,
			userModelOpen: false,
			first_name: "",
			last_name: "",
			email: "",
			phone: "",
			location: "",
			city: "",
			state: "",
			country: "",
			zipcode: "",
			first_name_error: false,
			last_name_error: false,
			phone_error:false,
			zipcode_error:false,
			ChangePasswordModal: false


		})
	}

	handleModelClose = () => {
		this.setState({
			open: false,
			user_image: null,
			selected_user_image_name: "",


		});

	};
	
	validateZipcode(zipcode) {
		var re = /^([A-Za-z]{2}\s\d{5})$|^(\d{5})$|^([a-zA-Z]{2}-\d{5})$/
		return re.test(zipcode);
     }

    validatePhone(phone) {
		var re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\\./0-9]*$/
		return re.test(phone);
     }

	buttonchange = async () => {
		let isError = false;
		if (this.state.first_name === "") {
			this.setState({ first_name_error: true })
			isError = true
		}
		if (this.state.last_name === "") {
			this.setState({ last_name_error: true })
			isError = true
		}
		if(this.state.phone !== "" &&this.state.phone !== null){
            if (this.state.phone.length >= 10 ) {
                if (!this.validatePhone(this.state.phone) === true) {
                this.setState({ phone_error: true });
                isError = true
            }
            }
            else {
                this.setState({ phone_error: true });
                isError = true  
            }
        }
		
		if(this.state.zipcode !== ""&&this.state.zipcode !== null){
           
			if (this.state.zipcode.length >=5 ) {
                if (!this.validateZipcode(this.state.zipcode) === true) {
                this.setState({ zipcode_error: true });
                isError = true
            }
            }
            else {
                this.setState({ zipcode_error: true });
                isError = true  
            }
        }

		if (isError === false) {
			// alert(JSON.stringify(this.state.first_name));
			const id = this.state.myUser.id;
			//console.log("_________________"+JSON.stringify(id));
			// console.log("_________________"+JSON.stringify(this.state));

			await this.props.dispatch(updateUser(this, this.state, id));

			this.setState({
				open: true,
				userModelOpen: false,
				first_name: "",
				last_name: "",
				email: "",
				phone: "",
				location: "",
				city: "",
				state: "",
				country: "",
				zipcode: "",
				first_name_error: false,
				last_name_error: false,
				user_image: null,
				selected_user_image_name: "",
				ChangePasswordModal: false


			});
		}
	}


	componentDidMount() {
		this.defaultMenu()

	}

	defaultMenu() {
		let url = window.location.pathname.split('/')[1];
		let menu = 3
		if (url === "libraries") {
			menu = 4
		} else if (url === "teams") {
			menu = 5
		} else if (url === "users") {
			menu = 6
		}
		else {
			menu = 3
		}
		this.setState({ menu })
	}

	userImage = ({ target }) => {

		this.setState({ user_image: target.files[0], selected_user_image_name: target.files[0].name });
	};

	handleChange = event => {
		this.setState({ auth: event.target.checked });
	};

	handleMenu = event => {
		this.setState({ anchorEl: event.currentTarget });
	};

	handleClose = () => {
		this.setState({ anchorEl: null });
	};

	handleSignout = () => {
		localStorage.removeItem('token');
		window.location.href = '/';
	}

	ChangePassword = () => {
		this.setState({ ChangePasswordModal : true})
	}

	submitPassword = () => {

		let isError = false;

		if (this.state.password !== null && this.state.password !== "") {
			if (!(this.state.password.length >= 8)) {
				this.setState({ invalid_password_error: true })
				isError = true
			}
		} else {
			this.setState({ password_error: true })
			isError = true
		}

		if (this.state.confirm_password !== null && this.state.confirm_password !== "") {
			if (!(this.state.password === this.state.confirm_password)) {
				this.setState({ invalid_confirm_password_error: true })
				isError = true
			}
		} else {
			this.setState({ confirm_password_error: true })
			isError = true
		}
		if (isError === false) {
			this.props.dispatch(changePassword(this, this.state));
		}
	}
	handleClosePassword = () => {
		this.setState({password: null, confirm_password: null, confirm_password_error: false,password_error: false,ChangePasswordModal: false})
	}

	render() {
		const { classes } = this.props;
		const { auth, anchorEl } = this.state;
		const open = Boolean(anchorEl);

		const { mobileMoreAnchorEl } = this.state;
		const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

		const renderMobileMenu = (
			auth && (
			<Menu
				anchorEl={mobileMoreAnchorEl}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				transformOrigin={{ vertical: 'top', horizontal: 'right' }}
				open={isMobileMenuOpen}
				onClose={this.handleMenuClose}
			>
				{(this.props.defaultRole === "THUNDERBOT") &&
					<MenuItem onClick={this.handleMobileMenuClose}>
						<Button component={Link} to={`/users`} onClick={() => this.setState({ menu: 6 })} color="inherit" style={this.state.menu === 6 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>Users</Button>
					</MenuItem>
				}
				{(this.props.defaultRole === "LIBRARIAN" || this.props.defaultRole === "THUNDERBOT") &&									
					<MenuItem onClick={this.handleMobileMenuClose}>
						<Button component={Link} to={`/libraries`} onClick={() => this.setState({ menu: 4 })} color="inherit" style={this.state.menu === 4 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>Library</Button>
					</MenuItem>
				}
				
				{(this.props.defaultRole === "COACH" || this.props.defaultRole === "THUNDERBOT") &&									
					<MenuItem onClick={this.handleMobileMenuClose}>
						<Button component={Link} to={`/teams`} onClick={() => this.setState({ menu: 5 })} color="inherit" style={this.state.menu === 5 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>FLLTeams</Button>
					</MenuItem>
				}
				<MenuItem onClick={this.handleModelOpen}>
					<Button onClick={() => this.setState({ menu: 7 })} color="inherit" style={this.state.menu === 7 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>Profile</Button>
				</MenuItem>
				<MenuItem onClick={this.ChangePassword}>
					<Button onClick={() => this.setState({ menu: 8 })} color="inherit" style={this.state.menu === 8 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>Change Password</Button>
				</MenuItem>
				<MenuItem onClick={this.handleSignout}>
					<Button onClick={() => this.setState({ menu: 8 })} color="inherit" style={this.state.menu === 8 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>Sign Out</Button>
				</MenuItem>
					
			</Menu>
			)
		);

		const renderMenu = (
			<Menu
				id="menu-appbar"
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				open={open}
				onClose={this.handleClose}
			>
			<MenuItem className={classes.menuItem} onClick={this.handleModelOpen}>
          <ListItemIcon className={classes.icon}>
            <Person />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary="Profile" />
        </MenuItem>
				<MenuItem className={classes.menuItem} onClick={this.ChangePassword}>
          <ListItemIcon className={classes.icon}>
            <VpnKey />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary="Change Password" />
        </MenuItem>
				<MenuItem className={classes.menuItem} onClick={this.handleSignout}>
          <ListItemIcon className={classes.icon}>
            <Lock />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary="Sign out" />
        </MenuItem>
				{/* <MenuItem onClick={this.handleModelOpen}>Profile</MenuItem> */}
				{/* <MenuItem onClick={this.handleModelOpen}>Change password</MenuItem>
				<MenuItem onClick={this.handleSignout}>Sign out</MenuItem> */}
			</Menu>
		);

		return (
			<div className={classes.root}>
				<AppBar position="static" className={classes.gradientBackground}>
					<Toolbar>
						<Typography variant="h5" color="inherit" className={classes.grow}>
							<strong>Thunder</strong>Bots
            			</Typography>
						{auth && (
							<div>
								<div className={classes.sectionDesktop}>
									{(this.props.defaultRole === "THUNDERBOT") &&									
										<Button component={Link} to={`/users`} onClick={() => this.setState({ menu: 6 })} color="inherit" style={this.state.menu === 6 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>Users</Button>									
									}

									{(this.props.defaultRole === "LIBRARIAN" || this.props.defaultRole === "THUNDERBOT") &&									
										<Button component={Link} to={`/libraries`} onClick={() => this.setState({ menu: 4 })} color="inherit" style={this.state.menu === 4 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>Library</Button>									
									}

									{(this.props.defaultRole === "COACH" || this.props.defaultRole === "THUNDERBOT") &&									
										<Button component={Link} to={`/teams`} onClick={() => this.setState({ menu: 5 })} color="inherit" style={this.state.menu === 5 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>FLLTeams</Button>									
									}

									<IconButton
										aria-owns={open ? 'menu-appbar' : undefined}
										aria-haspopup="true"
										onClick={this.handleMenu}
										color="inherit"
									>
										<AccountCircle />
									</IconButton>
									<Menu
										id="menu-appbar"
										anchorEl={anchorEl}
										anchorOrigin={{
											vertical: 'top',
											horizontal: 'right',
										}}
										transformOrigin={{
											vertical: 'top',
											horizontal: 'right',
										}}
										open={open}
										onClose={this.handleClose}
									>
										<MenuItem onClick={this.handleModelOpen}>Profile</MenuItem>
										<MenuItem onClick={this.handleSignout}>Sign out</MenuItem>
									</Menu>
								</div>

								<div className={classes.sectionMobile}>
									<IconButton aria-haspopup="true" onClick={this.handleMobileMenuOpen} color="inherit">
										<MenuIcon />
									</IconButton>
								</div>


								<Modal
									aria-labelledby="simple-modal-title"
									aria-describedby="simple-modal-description"
									open={this.state.open}
									onClose={this.handleModelClose}
									disableBackdropClick={true}
								>
									<div style={getModalStyle()} className={classes.paper1}>
										<div className={classes.closeButtonFab}>
											<Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleModelClose}>
												<ClearIcon />
											</Fab>
										</div>

										<div className={classes.card}>
											<Grid container spacing={24}>
												<Grid item xs={12}>
												<Typography component="p" style={{ color: 'white',  fontSize: 20 ,alignSelf:'center',justifyContent: 'center',textAlign:'center', alignItems: 'center',marginBottom:55, }}>
												{this.props.user.first_name} {this.props.user.last_name}
												<IconButton onClick={this.handleUserModelOpen} style={{justifyContent: 'center', alignItems: 'center',textAlign:'center'}} >
												<FontAwesomeIcon icon="pencil-alt" style={{ fontSize: 15, color: "#ffff24" }} />
												</IconButton>
											   </Typography>
												</Grid>												
											</Grid>
											<Grid container justify="center" alignItems="center" color= 'white' marginBottom = '-50'>
												<Avatar alt="Remy Sharp"
												src={Object.keys(this.props.user).length > 0 ?
												this.props.user.attachments.length > 0 ?
												`${ATTACHMENT_END_POINT}${this.props.user.attachments[0].file_name}` : notfound : notfound}
												className={classes.bigAvatar} />
											</Grid>
										 </div>

										<Card className={classes.card1}>
											<CardContent >
												<List className={classes.root}>
												<ListItem>
												  <Avatar>
													<Email />
												  </Avatar>
												  <ListItemText 
												  primary={this.props.user.email}
												   />
												</ListItem>
												<ListItem>
												  <Avatar>
													<Phone />
												  </Avatar>
												  <ListItemText 
												  primary={this.props.user.phone === "null" ? "" : this.props.user.phone}
												  />
												</ListItem>
												<ListItem  >
												  <Avatar>
													<Home />
												  </Avatar>
												  <ListItemText 
												  primary={`
													  ${(this.props.user.location !== "null" && this.props.user.location !== "" && this.props.user.location !== null) ?(this.props.user.city!=="" ||this.props.user.state!=="" || this.props.user.country!==""|| this.props.user.zipcode!=="" )? (this.props.user.location+","):(this.props.user.location ) : ""} 
													  ${(this.props.user.city !== "null" && this.props.user.city !== "" && this.props.user.city !== null) ? (this.props.user.state!=="" || this.props.user.country!==""|| this.props.user.zipcode!=="" )? (this.props.user.city+"," ):(this.props.user.city ) : ""} 
													  ${(this.props.user.state !== "null" && this.props.user.state !== "" && this.props.user.state !== null) ? (this.props.user.country!==""|| this.props.user.zipcode!=="" )? (this.props.user.state+ "," ):(this.props.user.state ): ""}
													  ${(this.props.user.country !== "null" && this.props.user.country !== "" && this.props.user.country !== null) ? ( this.props.user.zipcode!=="" )?  (this.props.user.country+","):(this.props.user.country ) : ""}
													  ${(this.props.user.zipcode !== "null" && this.props.user.zipcode !== "" && this.props.user.zipcode !== null) ? this.props.user.zipcode : ""}
													`}
												   />
												</ListItem>
											  </List>

											</CardContent>
										</Card>
									</div>
								</Modal>

								<Modal
									aria-labelledby="simple-modal-title"
									aria-describedby="simple-modal-description"
									open={this.state.userModelOpen}
									onClose={this.handleClose}
									disableBackdropClick={true}
								>
									<div style={getModalStyle()} className={classes.paper}>
										<div className={classes.editCloseButtonFab2}>
											<Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleUserModelClose}>
												<ClearIcon />
											</Fab>
										</div>
										<Typography variant="h6" style={{ marginBottom: 15 }}>
											Edit UserProfile
										</Typography>
										<Grid container spacing={8}>
											<Grid item xs={6} >
												<TextField
													id="standard-name"
													label="First name"
													required
													fullWidth
													className={classes.textField}
													value={this.state.first_name}
													margin="normal"
													InputProps={{ classes: { input: classes.inputStyle } }}
													InputLabelProps={{
														shrink: true,
														FormLabelClasses: {
															root: classes.labelRoot
														}
													}}
													helperText={this.state.first_name_error === true ? "Please enter First name" : false}
													error={this.state.first_name_error === true ? true : false}
													onChange={(event) => this.setState({ first_name: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1), first_name_error: false })}
												/>
											</Grid>
											<Grid item xs={6} >
												<TextField
													id="standard-name"
													label="Last name"
													required
													fullWidth
													className={classes.textField}
													value={this.state.last_name}
													margin="normal"
													InputProps={{ classes: { input: classes.inputStyle } }}
													InputLabelProps={{
														shrink: true,
														FormLabelClasses: {
															root: classes.labelRoot
														}
													}}
													helperText={this.state.last_name_error === true ? "Please enter Last name" : false}
													error={this.state.last_name_error === true ? true : false}
													onChange={(event) => this.setState({ last_name: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1), last_name_error: false })}
												/>
											</Grid>
											<Grid item xs={6} >
												<TextField
													id="standard-name"
													label="Email"
													fullWidth
                                                    disabled="true"
													className={classes.textField}
													value={this.state.email}
													// onChange={(event) => this.setState({ location: event.target.value })}
													margin="normal"
													InputProps={{ classes: { input: classes.inputStyle } }}
													InputLabelProps={{
														shrink: true,
														FormLabelClasses: {
															root: classes.labelRoot
														}
													}}
												/>
											</Grid>

											<Grid item xs={6} >
												<TextField
													id="standard-name"
													label="Phone"
													fullWidth
													//type="number"
													className={classes.textField}
													value={this.state.phone}
													//onChange={(event) => this.setState({ phone: event.target.value })}
													onChange={(event) => this.setState({ phone: event.target.value,phone_error: false })}
													margin="normal"
													InputProps={{ classes: { input: classes.inputStyle } }}
													InputLabelProps={{
														shrink: true,
														FormLabelClasses: {
															root: classes.labelRoot
														}
													}}
													helperText={this.state.phone_error === true ? "Please enter valid phone number" : false}
													error={this.state.phone_error === true ? true : false}
												/>
											</Grid>
											<Grid item xs={6} >
												<TextField
													id="standard-name"
													label="Location"
													fullWidth

													className={classes.textField}
													value={this.state.location}
													onChange={(event) => this.setState({ location: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) })}
													margin="normal"
													InputProps={{ classes: { input: classes.inputStyle } }}
													InputLabelProps={{
														shrink: true,
														FormLabelClasses: {
															root: classes.labelRoot
														}
													}}
												/>
											</Grid>
											<Grid item xs={6} >
												<TextField
													id="standard-name"
													label="City"
													fullWidth
													className={classes.textField}
													value={this.state.city}
													onChange={(event) => this.setState({ city: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) })}
													margin="normal"
													InputProps={{ classes: { input: classes.inputStyle } }}
													InputLabelProps={{
														shrink: true,
														FormLabelClasses: {
															root: classes.labelRoot
														}
													}}
												/>
											</Grid>
											<Grid item xs={6} >
												<TextField
													id="standard-name"
													label="State"
													fullWidth
													className={classes.textField}
													value={this.state.state}
													onChange={(event) => this.setState({ state: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) })}
													margin="normal"
													InputProps={{ classes: { input: classes.inputStyle } }}
													InputLabelProps={{
														shrink: true,
														FormLabelClasses: {
															root: classes.labelRoot
														}
													}}
												/>

											</Grid>
											<Grid item xs={6} >
												<TextField
													id="standard-name"
													label="Country"
													fullWidth
													className={classes.textField}
													value={this.state.country}
													onChange={(event) => this.setState({ country: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) })}
													margin="normal"
													InputProps={{ classes: { input: classes.inputStyle } }}
													InputLabelProps={{
														shrink: true,
														FormLabelClasses: {
															root: classes.labelRoot
														}
													}}
												/>
											</Grid>
											<Grid item xs={6} >
												<TextField
													id="standard-name"
													label="Zipcode"
													fullWidth
													//type="number"
													className={classes.textField}
													value={this.state.zipcode}
													//onChange={(event) => this.setState({ zipcode: event.target.value })}
													onChange={(event) => this.setState({ zipcode: event.target.value,zipcode_error: false })}
													margin="normal"
													InputProps={{ classes: { input: classes.inputStyle } }}
													InputLabelProps={{
														shrink: true,
														FormLabelClasses: {
															root: classes.labelRoot
														}
													}}
													helperText={this.state.zipcode_error === true ? "Please enter valid Zipcode" : false}
													error={this.state.zipcode_error === true ? true : false}
												/>
											</Grid>
											<Grid item xs={6} >
												<input
													accept="image/*"
													className={classes.input}
													id="contained-button-file"
													type="file"
													onChange={this.userImage}
												/>
												<label htmlFor="contained-button-file">
													<Button variant="outlined" component="span" className={classes.gradientButton} style={{ marginTop: 10 }}>
														Upload user image
															<CloudUploadIcon className={classes.rightIcon} />
													</Button>
												</label>
												<Typography style={{ marginLeft: 5 }} >{this.state.selected_user_image_name}</Typography>

											</Grid>

											<Grid item xs={12} >
												<div style={{ textAlign: "center" }}>
													<Button variant="contained" color="secondary" size="small" className={classes.cancelbutton} onClick={this.handleUserModelClose}>
														cancel
														</Button>
													<Button variant="contained" size="small" className={classes.button1} onClick={this.buttonchange}>
														Submit
														</Button>
												</div>
											</Grid>
										</Grid>
									</div>
								</Modal>
								<Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.ChangePasswordModal}
                    onClose={this.handleClose}
                    disableBackdropClick={true}
                >
                    <div style={getModalStyle()} className={classes.paperFortimeSlot}>
                        <div className={classes.closeButtonF}>
                            <Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClosePassword}>
                                <ClearIcon />
                            </Fab>
                        </div>

                        <Typography variant="h6" >
															Change password
												</Typography>
                        <Grid container spacing={8} style={{ marginTop: 15 }}>
                            <Grid item xs={12} >
														<TextField
                                id="standard"
                                label="Password"
                                type="password"
                                required
                                fullWidth
                                value={this.state.password}
                                margin="normal"
                                InputProps={{ classes: { input: classes.inputStyle } }}
                                InputLabelProps={{
                                shrink: true,
                                FormLabelClasses: {
                                    root: classes.labelRoot
                                  }
                                }}
                                error={this.state.password_error === true ? true : this.state.invalid_password_error === true ? true : false}
                                helperText={this.state.password_error === true ? "Please enter password" : this.state.invalid_password_error === true ? "Please enter vaild password" : false}
                                onChange={(event) => this.setState({ password: event.target.value, password_error: false, invalid_password_error: false })}
                              />
                                
                            </Grid>
                            <Grid item xs={12} >
														<TextField
																id="name"
																type="password"
																label="Confirm Password"
																required
																fullWidth
																value={this.state.confirm_password}
																margin="normal"
																InputProps={{ classes: { input: classes.inputStyle } }}
																InputLabelProps={{
																		shrink: true,
																		FormLabelClasses: {
																				root: classes.labelRoot
																		}
																}}
																
																error={this.state.confirm_password_error === true ? true : this.state.invalid_confirm_password_error === true ? true : false}
																helperText={this.state.confirm_password_error === true ? "Please enter confirm password" : this.state.invalid_confirm_password_error === true ? "Please enter same password" : null}
																onChange={(event) => this.setState({ confirm_password: event.target.value, confirm_password_error: false, invalid_confirm_password_error: false })}
														/>
                            </Grid>
                       
                            <Grid item xs={12} >
                                <div style={{ textAlign: "center" }}>
                                    <Button variant="contained" color="secondary" size="small" className={classes.cancelbutton} onClick={this.handleClosePassword}>
                                        cancel
                                    </Button>
                                    <Button variant="contained" size="small" className={classes.button1} onClick={this.submitPassword}>
                                        Submit
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>

                </Modal>
							</div>
						)}
					</Toolbar>
				</AppBar>
				{renderMenu}
      			{renderMobileMenu}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		defaultRole: state.SessionReducer.defaultRole,
		user: state.SessionReducer.user,
		// users:state.UserReducer.users
	}
}

LaunchHeader.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), connect(mapStateToProps))(LaunchHeader);